import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ReplyMessage = ({ replyToMessage, onCancelReply }) => {
  if (!replyToMessage) return null;

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        py: '8px',
        px: '12px',
        background: '#F8FAFD',
        borderLeft: '3px solid #60A5FA',
        alignItems: 'center',
        justifyContent: 'space-between',
        animation: 'slideInUp 0.2s ease-out',
        margin: '6px 10px 0',
        borderRadius: '10px 10px 8px 8px'
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography 
          sx={{ 
            fontSize: '11px', 
            fontWeight: 700, 
            color: '#60A5FA', 
            textTransform: 'uppercase', 
            letterSpacing: '0.08em',
            marginBottom: '2px'
          }}
        >
          {replyToMessage.senderName}
        </Typography>
        <Typography 
          sx={{ 
            fontSize: '13px', 
            color: '#475569', 
            fontFamily: "'Inter', sans-serif",
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {replyToMessage.isfile ? `📎 File` : (replyToMessage.content || "Empty message")}
        </Typography>
      </Box>
      
      <IconButton 
        size="small" 
        onClick={onCancelReply}
        sx={{ color: '#64748B', '&:hover': { background: 'rgba(0,0,0,0.04)' } }}
      >
        <CloseIcon sx={{ fontSize: '18px' }} />
      </IconButton>
    </Box>
  );
};

export default ReplyMessage;

